/** GridRow — `grid` layout. Month event grid. Provides the `grid` slot. */
import { LayoutRow } from "./layout-row.ts";

/** The `grid` layout row: the month event grid, providing the `grid` slot. */
export class GridRow extends LayoutRow {
  // No additional config beyond the base yet.
}
